import { useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const navigate = useNavigate();
  const featured = articles.filter((a) => a.featured).slice(0, 3);

  const handleClick = (slug: string) => {
    navigate(`/article/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">精选推荐</h2>
            <p className="text-sm text-foreground-500 mt-1">编辑精选的热门麻将文章</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((article, idx) => (
            <article
              key={article.slug}
              onClick={() => handleClick(article.slug)}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200 transition-all"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx === 0 ? undefined : 'lazy'}
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap">
                    推荐
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span>{article.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}